import { useState } from "react";
import req from "../../axios/interceptedAxiosInstance";
import comment from "../../assets/comment.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faNairaSign } from "@fortawesome/free-solid-svg-icons";
import PagePadding from "../../layouts/PagePadding";
import empty from "../../assets/empty.png";
import { successToast } from "../../notification/notification";
import useAuth from "../../hooks/useAuth";
import { removeFromFav } from "../../slice/favourite/favouriteSlice";
import { useDispatch } from "react-redux";
import { removeDuplicate } from "../../utils/remove-duplicate/removeDuplicate";

const ItemsILove = () => {
  const { favourite } = useAuth();
  const [disable, setDisable] = useState(false);
  const dispatch = useDispatch();

  const fav = removeDuplicate(favourite, (i) => i.product.id);


  const handleRemove = async (product_name) => {
    setDisable(true);
    try {
      const id = await favourite.filter(
        (item) => item.product.product_name === product_name
      );
      const response = await req.delete(`favourite/${id[0].id}`);
      dispatch(removeFromFav(id[0].id));
      successToast(`${response.data.message}: item removed from favourite`);
      setDisable(false);
    } catch (error) {
      console.log(error);
      setDisable(false);
    }
  };

  return (
    <PagePadding>
      {fav.length < 1 ? (
        <div className="flex justify-center mt-8">
          <div className="w-fit">
            <img src={empty} alt="empty" className="m-auto" />
            <p className="mt-3 text-center">You have no favourite item yet </p>
          </div>
        </div>
      ) : (
        fav.length > 0 && (
          <div className="flex flex-wrap gap-4 md:gap-5 mt-8">
            {fav.map((fav) => (
              <div
                key={Math.random()}
                className="w-[46.5%] md:w-[31%] lg:w-[160.5px] xl:w-[14%]"
              >
                <div>
                  {/* <img/> */}
                  <p className="text-sm">
                    {fav.product.seller.full_name} Thrift Shop
                  </p>
                </div>
                <div>
                  <img
                    src={fav.product.product_image.front_view}
                    alt="items you love"
                    className="h-[150px] md:h-200 lg:h-[170px] w-full mt-2"
                  />
                  <div className="flex flex-col md:flex-row md:justify-between md:items-center mt-2">
                    <div>
                      <div className="flex items-center gap-1">
                        <img src={comment} alt="comment" className="w-4 h-2" />
                        <div className="flex items-center">
                          <FontAwesomeIcon
                            icon={faNairaSign}
                            className="text-label text-sm"
                          />
                          <p className="text-label text-sm">
                            {fav.product.product_prices[0].price}
                          </p>
                        </div>
                      </div>
                    </div>
                    <button
                      className="flex gap-2 items-center"
                      onClick={() => handleRemove(fav.product.product_name)}
                      disabled={disable}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        className="bi bi-trash text-label"
                        viewBox="0 0 16 16"
                      >
                        <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z" />
                        <path
                          fillRule="evenodd"
                          d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4L4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z"
                        />
                      </svg>
                      <p className="text-label text-sm">Delete</p>
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )
      )}
    </PagePadding>
  );
};

export default ItemsILove;
